import User from "../../../model/user/User";

/**
 * User login successful action.
 */
export const USER_LOGIN_SUCCESSFUL = "USER_LOGIN_SUCCESSFUL";
export type USER_LOGIN_SUCCESSFUL = { user: User };

/**
 *  User logout action.
 */
export const USER_LOGOUT = "USER_LOGOUT";
export type USER_LOGOUT = {};

/**
 * Fetch organisation users action.
 * @type {string}
 */
export const USERS_FETCHED = "USERS_FETCHED";
export  type USERS_FETCHED = { users: User[] };

export const USER_CREATED = "USER_CREATED";
export  type USER_CREATED = { user: User };
/**
 * Accept terms of service action
 */
export const TOS_ACCEPTED = "TOS_ACCEPTED";
export type TOS_ACCEPTED = {};

/**
 * User update action
 */
export const USER_UPDATED = "USER_UPDATED";
export  type USER_UPDATED = { user: User };

/**
 * Change user suspend action
 */
export const USER_SUSPEND_UPDATED = "USER_SUSPEND_UPDATED";
export  type USER_SUSPEND_UPDATED = { userId: string, disabled: boolean };